import { StatusServerlessProject } from '@/service/serverless-gpu/type';

import { StatusServerlessProjectLabel } from '@/service/serverless-gpu/type';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

const BadgeProjectStatus = ({
  status,
}: {
  status: StatusServerlessProject;
}) => {
  return (
    <Badge
      variant={'secondary'}
      className={cn(
        'h-fit',
        status === StatusServerlessProject.Active &&
          'bg-success/10 text-success',
        status === StatusServerlessProject.Deleted &&
          'bg-muted text-muted-foreground'
      )}
    >
      {StatusServerlessProjectLabel[status]}
    </Badge>
  );
};

export default BadgeProjectStatus;
